/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters } from 'vuex';
import stockService from './../../../../services/stock';
import stockTransformer from './../../../../transformers/stock';
import warehouseService from './../../../../services/warehouse';
import productService from './../../../../services/product';
import Forms from './../../../../utils/forms/forms';
import store from './../../../../store';

export default {
  data() {
    return {
      formBasicInformation: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        warehouseId: {
          value: '',
          type: 'select',
        },
        transactionDate: {
          value: new Date(),
          type: 'date',
          attributes: {
            datePickerOptions: {
              disabledDate: this.disabledDate,
            },
          },
        },
        descriptions: {
          value: '',
          type: 'textarea',
        },
      }),
      loading: true,
      tabIndex: 'first',
      fields: {
        productId: {
          value: '',
          type: 'autocomplete',
          attributes: {
            isSearch: true,
            searchMethod: this.searchMethod,
            loading: true,
          },
        },
        batchId: {
          value: '',
          type: 'select',
        },
        physicalCount: {
          value: '0',
          type: 'number',
        },
        currentCount: {
          value: '0',
          type: 'number',
          disabled: true,
        },
        variance: {
          value: '0',
          type: 'number',
          disabled: true,
        },
      },
      currentStock: {
        products: [],
        warehouse: {
          name: '',
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      currentStockProducts: 'currentStockProductsCustom',
      warehouses: 'allWarehouses',
    }),

    isSharedToYou() {
      const data = this.warehouses.items.filter(item => item.id === this.formBasicInformation.warehouseId);
      if (data.length > 0) {
        return data[0].isSharedToYou;
      }
      return false;
    },
  },

  watch: {
    warehouses(warehouses) {
      this.formBasicInformation.setOptions('warehouseId', warehouses.items.map(item => ({ id: item.id, name: item.name + (item.isLocked ? this.$t('static.warehouse.info.locked') : ''), disabled: item.isLocked })));
    },
    'formBasicInformation.warehouseId': function (warehouseId) {
      store.dispatch('setStockSelectedWarehouse', warehouseId);
    },

    currentStock(currentStock) {
      store.dispatch('allCurrentStockProductsCustom', this.currentStock.products.map(c => ({
        qty: c.qty,
        id: c.product.id,
        batchId: c.batchId,
        variance: c.variance,
        productId: c.product,
        physicalCount: c.physicalCount,
        currentCount: c.currentCount,
      })));
    },
  },

  created() {

  },

  methods: {

    disabledDate(date) {
      const nextDate = date.setDate(date.getDate());
      const prevDate = date.setDate(date.getDate() + 14);
      return prevDate < new Date() || nextDate > new Date();
    },

    /**
     * Method to store the client
     */
    update() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const client = stockTransformer.send(
        Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts })
      );

      stockService.update(this.$route.params.id, client)
        .then(() => {
          this.$message({
            message: this.$t('static.stock.create.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'inventory.stock.index',
          });
        }).catch((errors) => {
          this.formBasicInformation.loading = false;
          this.formBasicInformation.recordErrors(errors);
          const message = errors.message;
          if (errors.message) {
            this.$message({
              showClose: true,
              message,
              customClass: 'error',
            });
          }
        });
    },

    updateDraft() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const client = stockTransformer.send(
        Object.assign({}, this.formBasicInformation.data(), { products: this.currentStockProducts })
      );

      stockService.updateDraft(this.$route.params.id, client)
        .then(() => {
          this.$message({
            message: this.$t('static.stock.draft.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'inventory.stock.index',
          });
        }).catch((errors) => {
          this.formBasicInformation.loading = false;
          this.formBasicInformation.recordErrors(errors);
          const message = errors.message;
          if (errors.message) {
            this.$message({
              showClose: true,
              message,
              customClass: 'error',
            });
          }
        });
    },

    downloadProduct() {
      stockService.downloadProduct(this.formBasicInformation.warehouseId);
    },
    searchMethod(search, field) {
      return Promise.all([
        productService.searchAll({ search }),
      ]);
    },

    deleteDraft() {
      const me = this;
      this.$confirm(this.$t('static.stock.draft.deleteMessage'), 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        me.formBasicInformation.loading = true;
        stockService.destroy(this.$route.params.id).then(() => {
          me.$router.push({
            name: 'inventory.stock.index',
          });
        });
      }).catch(() => {

      });
    },
  },
  mounted() {
    store.dispatch('allCurrentStockProductsCustom', []);
    Promise.all([
      warehouseService.all(),
      stockService.show(this.$route.params.id),
    ]).then((data) => {
      this.formBasicInformation.assignData(data[1]);
      this.currentStock = data[1];
      this.loading = false;
    });
  },
  components: {
    VForm: require('./../../../../components/form/form.vue'),
    VProductsTable: require('./../../../../components/productTableWithCustomForm/productTableWithCustomForm.vue'),
    VMessage: require('./../../../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/stock/edit/edit.js